import Chip, { type ChipVariantKey } from "@imminently/decisively-ui/Chip";

interface AdapterStepHeaderProps {
  title: string;
  status: string;
  variant: ChipVariantKey;
}

export const AdapterStepHeader = ({ title, status, variant }: AdapterStepHeaderProps) => (
  <div className="flex items-center justify-between gap-3">
    <h3 className="text-base font-semibold text-foreground">{title}</h3>
    <Chip size="sm" variant={variant} label={status} />
  </div>
);
